var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrowserWalletLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "ionicon",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Wallet") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 144,
    width: 416,
    height: 288,
    rx: 48,
    ry: 48,
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinejoin: "round",
    strokeWidth: 32
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M411.36 144v-30A50 50 0 00352 64.9L88.64 109.85A50 50 0 0048 159v49",
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinejoin: "round",
    strokeWidth: 32
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M368 320a32 32 0 1132-32 32 32 0 01-32 32z",
    fill: "#FFFFFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowserWalletLogoWhite);
export default __webpack_public_path__ + "static/media/browser_wallet_logo_white.20abb16f927f5de43ec1e93bc2adc53f.svg";
export { ForwardRef as ReactComponent };